import _get from 'lodash/get';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { Row, Col, Button } from 'reactstrap';
import STYLES from '../STYLES';
import { CARRIER_BASE_URL } from '../../../utils/constants';
import { updateRegistration } from '../../../actions/registration/registrationActions';
import DriverModal from './DocumentsModal';
import DriverView from './DocumentsView';
import ConfirmationModal from '../../../modals/ConfirmationModal';

class DocumentsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMsg: '',
      successMsg: '',
      isDriverOpen: false,
      isConfirmOpen: false,
    };
  }

  onDriverModalClose = (data) => {
    const value = _get(this, 'props.documents', []);
    value.push(data);
    this.props.updateRegistration({ documents: value });
    this.toggleDriver();
  };
  toggleDriver = () => {
    this.setState({
      isDriverOpen: !this.state.isDriverOpen,
    });
  };

  onItemDelete = ({ item }) => {
    const value = _get(this, 'props.documents', []);
    const items = value.filter((i) => i !== item);
    this.props.updateRegistration({ documents: items });
    this.toggleConfirm({ item: null });
  };

  toggleConfirm = ({ item, type }) => {
    this.setState({
      isConfirmOpen: !this.state.isConfirmOpen,
      item: item,
      type: type,
    });
  };

  render() {
    const businessKey = _get(this, 'props.match.params.businessKey');
    const backUrl = `${CARRIER_BASE_URL}/${businessKey}/moreDetails`;
    const nextUrl = `${CARRIER_BASE_URL}/${businessKey}/review`;

    const { documents } = this.props;
    const { isConfirmOpen, isDriverOpen } = this.state;

    return (
      <div>
        {isConfirmOpen && (
          <ConfirmationModal
            message={'Are you sure to delete this document?'}
            isOpen={isConfirmOpen}
            toggle={() => this.toggleConfirm({ item: null })}
            onConfirm={() =>
              this.onItemDelete({
                item: this.state.item,
                type: this.state.type,
              })
            }
          />
        )}
        {isDriverOpen && (
          <DriverModal
            isOpen={this.state.isDriverOpen}
            toggle={this.toggleDriver}
            onClose={this.onDriverModalClose}
          />
        )}
        <Row>
          <Col md={12}>
            <Row
              style={{
                marginTop: 12,
              }}
            >
              <Col md={8} style={{ fontSize: 10, marginTop: 2 }}>
                <h5
                  style={{
                    textAlign: 'left',
                  }}
                >
                  Documents
                </h5>
              </Col>
              <Col md={4} style={{ textAlign: 'right' }}>
                <div>
                  {documents.length < 10 ? (
                    <Button
                      style={{
                        width: 100,
                        borderWidth: 0.5,
                      }}
                      color='primary'
                      className='btn btn-primary btn-sm'
                      onClick={this.toggleDriver}
                    >
                      Add
                    </Button>
                  ) : (
                    <span
                      style={{
                        fontSize: 10,
                        color: 'red',
                      }}
                    >
                      Can't add more then 10
                    </span>
                  )}
                </div>
              </Col>
            </Row>

            {documents.map((item, i) => {
              return (
                <DriverView
                  md={12}
                  drivers={item}
                  onClick={() => this.toggleConfirm({ item: item, type: 2 })}
                />
              );
            })}
          </Col>
        </Row>
        <Row style={STYLES.BUTTON_WRAPPER}>
          <Col xs='6'>
            <Link
              to={backUrl}
              className='btn btn-warning btn-sm'
              style={STYLES.BUTTON_BACK}
            >
              BACK (MORE DETAILS)
            </Link>
          </Col>
          <Col xs='6'>
            <Link
              to={nextUrl}
              className='btn btn-primary btn-sm'
              style={STYLES.BUTTON_NEXT}
            >
              NEXT (REVIEW)
            </Link>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    business: _get(state, 'appData.business', {}),
    documents: _get(state, 'carrierData.documents', []),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateRegistration,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DocumentsForm)
);
